const initialState = {
  data: [],
};
  
const udzialyKontaAktUReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA_AKT_U':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaAktUReducer;